<template>
  <el-dialog title='完成时间' :visible.sync='finishVisible' width='500px'>
    <div class='finish'>
      <span class='required'>完成日期：</span>
      <el-date-picker
        size='mini'
        style='width:calc(100% - 85px)'
        v-model='finishData.fulfilTime'
        type='datetime'
        value-format='yyyy-MM-dd HH:mm:ss'
        placeholder='选择日期时间' />
    </div>
    <span slot='footer' class='dialog-footer'>
        <el-button size='mini' @click='finishVisible = false'>取 消</el-button>
        <el-button size='mini' :loading='addLoad' type='primary'
                   @click='finishFinish'>确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { vehicleDeployInfoFinish } from '@/service/vehiclelog'

export default {
  name: 'carFinish',
  data() {
    return {
      finishVisible: false,
      addLoad: false,
      finishData: {
        id: '',
        fulfilTime: ''
      }
    }
  },
  methods: {
    openDialog(id) {
      this.finishVisible = true
      this.finishData.id = id
      this.finishData.fulfilTime = ''
    },
    // 完成 —— 确认
    async finishFinish() {
      if (!this.finishData || this.finishData.fulfilTime === '') return this.$message.error('请选择完成日期！')
      this.addLoad = true
      let res = await vehicleDeployInfoFinish(this.finishData)
      this.addLoad = false
      if (res.status !== 0) return this.$message.error(res.message)
      this.$message.success(res.message)
      this.finishVisible = false
      await this.$emit('getList')
    }
  }
}
</script>

<style lang='scss' scoped>
.finish {
  padding: 30px 50px;

  span {
    display: inline-block;
    width: 85px;
  }
}
</style>
